import React from "react";
import Grid from "../../components/Grid/Grid";
import data from "../../data/projects.json";
import "./Movies.css";

function Movies() {
  const items = data.filter((p) => p.category === "Commercials");
  return (
    <section className="Movies">
      <h1 className="Movies__title">Commercials</h1>
      {/* Same pattern as Narratives */}
      <Grid items={items} className="Grid--singleCol Grid--wide" />
    </section>
  );
}

export default Movies;
